<template>
    <a-month-picker
        :get-calendar-container="getPopupContainer"
        :value="value"
        :value-format="dateFormat"
        :format="dateFormat"
        :disabled-date="disabledDate"
        @update:value="onUpdateValue"
        style="width: 100%"
    />
</template>

<script>
import moment from "moment";

export default {
    name: "MonthPicker",
    emits: ["update:value"],
    props: {
        value: {
            type: String,
            default: null,
        },
        start: {
            type: String,
            default: null,
        },
        end: {
            type: String,
            default: null,
        },
    },
    setup(props, {emit}) {
        const disabledDate = (current) => {
            const beforeStartDate = props.start
                ? current.isBefore(moment(`${props.start}-01`).startOf("month"))
                : null;
            const afterEndDate = props.end
                ? current.isAfter(moment(`${props.end}-01`).endOf("month"))
                : null;
            return beforeStartDate || afterEndDate;
        };
        const onUpdateValue = (date) => {
            emit("update:value", date);
        };
        return {
            dateFormat: "YYYY-MM",
            disabledDate,
            onUpdateValue,
        };
    },
};
</script>

<style scoped>
</style>
